// eslint-disable-next-line import/no-internal-modules
import AlertComponent from '@insided/deprecated-control/ui-components/AlertComponent'

const ErrorList = ({ errors = [] }) => {
  if (!errors.length) return null

  return (
    <div className='content-errors'>
      {
      errors.map(({ errorMessage }) =>
        <AlertComponent messageType='error' message={errorMessage} key={errorMessage} />
      )
    }
    </div>
)
}

export default ErrorList
